import localization from "../../../../assets/localization";
import ChatService from "../../../../front-services/ChatService";

export default function PoweredBy({ language, assistantId }: any) {
  return (
    <div className="powered-by">
      {!ChatService.isIodah(assistantId) && (
        <>
          <span
            style={{ fontSize: "10px", color: "white", marginRight: "3px" }}
          >
            {localization.get(language).powered_by}
          </span>

          <a
            href={`https://plutonios.com?utm_source=${
              ChatService.isHM(assistantId) ? "hm" : "single"
            }`}
            target="_blank"
            rel="noreferrer"
            style={{
              fontSize: "11px",
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            Plutonios
            <img
              src="https://www.plutonios.com/plutonios_logo_icon.png"
              alt="Plutonios Logo"
              className="inline-block mr-1"
              style={{
                width: "10px",
                marginLeft: "2px",
                backgroundColor: "white",
                verticalAlign: "baseline",
                border: "1px solid white",
                borderRadius: "50%",
              }}
            />
          </a>
        </>
      )}
    </div>
  );
}
